import { useEffect } from "react";
import { useLocaleState } from "ra-core";

/**
 * First sign-in / MFA / password recovery should always be English so every
 * new user understands the flow before choosing a dashboard language in
 * onboarding. Persisted browser/store locale (e.g. da) would otherwise win.
 */
export function useForceEnglishLocale() {
  const [locale, setLocale] = useLocaleState();

  useEffect(() => {
    if (locale !== "en") {
      setLocale("en");
    }
  }, [locale, setLocale]);
}
